import PatientRealtimeActions from './patient-realtime-actions';
import angular from 'angular';
export default angular
    .module('doxy.realtime.components.PatientRealtimeActions', [])
    .service('patientRealtimeActions', PatientRealtimeActions).name;
